import { useEffect, useState } from 'react'

/**
 * One-toast-at-a-time notifications, fired from anywhere via toast('Copied').
 * A tiny event bus beats a context provider for something this small.
 */

export function toast(message, kind = 'info') {
  window.dispatchEvent(new CustomEvent('cdm:toast', { detail: { message, kind } }))
}

export function ToastHost() {
  const [current, setCurrent] = useState(null)

  useEffect(() => {
    let timer
    const onToast = (e) => {
      setCurrent(e.detail)
      clearTimeout(timer)
      timer = setTimeout(() => setCurrent(null), 2200)
    }
    window.addEventListener('cdm:toast', onToast)
    return () => {
      window.removeEventListener('cdm:toast', onToast)
      clearTimeout(timer)
    }
  }, [])

  if (!current) return null
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(72px+env(safe-area-inset-bottom))] z-[80] flex justify-center md:bottom-8">
      <div
        className={
          'rounded-full px-4 py-2 text-sm font-medium text-white shadow-lg ' +
          (current.kind === 'error' ? 'bg-danger' : 'bg-ink')
        }
      >
        {current.message}
      </div>
    </div>
  )
}
